import './AdminUserChickenTest.scss';
import Button from '@mui/material/Button';
import { useDispatch } from 'react-redux';
import { toggleAccountLock } from '../../../../../../slices/userSlice';
import { toast } from 'react-toastify';

function AdminUserChickenTest({ onClose, userId, accountLocked }) {
  const dispatch = useDispatch();

  const message = accountLocked
    ? "Are you sure you want to lock this account?"
    : "Are you sure you want to unlock this account?";

  const actionText = accountLocked ? "Lock" : "Unlock";

  async function handleAction() {
    try {
      await dispatch(toggleAccountLock({ userId, accountLocked })).unwrap();
      toast.success(accountLocked ? "Account locked!" : "Account unlocked!");
      onClose();
    } catch (err) {
      toast.error(err || "Action failed");
    }
  }

  return (
    <div className="admin-user-chicken-test">
    <div className="chicken-test-container">
    <div className="chicken-test-message">
        {message}
        <div className="chicken-test-buttons">
          <Button onClick={onClose} id="cancel-button">
            Cancel
          </Button>
          <Button onClick={handleAction} id="complete-button">
            {actionText}
          </Button>
        </div>
      </div>
    </div>
    </div>
  );
}

export default AdminUserChickenTest;